import { combineReducers } from "redux";
import WatchListGroups from "./WatchListGroups";
import particulatWatchlist from "./particularWatchList";
import getGloblePin from "./getGloblePin";
import searchWatchlist from "./searchWatchList";
import MyHoldings from "./myHoldings";
import MyPositions from "./myPositions";
export default combineReducers({
    WatchListGroups: WatchListGroups,
    particulatWatchlist: particulatWatchlist,
    getGloblePin: getGloblePin,
    searchWatchlist: searchWatchlist,
    MyHoldings: MyHoldings,
    MyPositions: MyPositions,
});
